module.exports = __webpack_public_path__ + "img/emoji_48.0adb6f7d.png";